import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PayOtherShortPaidReasonService {
  private selectedPayOtherShortPaidReason$: BehaviorSubject<boolean> =
    new BehaviorSubject(false);

  getShortpaidStatus(): Observable<boolean> {
    return this.selectedPayOtherShortPaidReason$.asObservable();
  }

  setShortpaidStatus(status: boolean) {
    this.selectedPayOtherShortPaidReason$.next(status);
  }
}
